// extracted by mini-css-extract-plugin
module.exports = {"root":"oZIVGiIohDyDtYmGcYA7","description":"mUkGqBTU3TYoLeDgMYHs","hours":"iPkvYuo4h5irpkkxCueA"};